function playback(backendAxiosInstance) {
  function playbackStreaming(playbackStreamingParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/streaming",
      playbackStreamingParams,
      {
        includeTimeZone: true,
        includeClientType: true
      }
    );
  }
  function playbackStop(playbackStopParams) {
    return backendAxiosInstance.post(
      "/experiences/v4/playback/stop",
      playbackStopParams,
      {
        includeTimeZone: true,
        includeClientType: true,
        fetchOptions: {
          keepalive: true
        }
      }
    );
  }
  return {
    playbackStreaming,
    playbackStop
  };
}

export { playback as default };
//# sourceMappingURL=playback.js.map
